"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _bluebird = require("bluebird");
require("core-js");
require("../config/firebase");
var _react = _interopRequireDefault(require("react"));
var _AppRegistry = _interopRequireDefault(require("react-native-web/dist/exports/AppRegistry"));
var _reactRouterDom = require("react-router-dom");
var _device = require("shared-libs/models/device");
var _deviceInfoProvider = require("browser/app/utils/device-info-provider");
require("../../../../vendor/jquery.resize");
require("../styles/app.scss");
var _apis = _interopRequireDefault(require("../models/apis"));
var _mobileWebApp = require("browser/mobile/pages/mobile-web-app");
var _history = require("../../history");
var _componentsContext = require("browser/contexts/components/components-context");
var _index = _interopRequireDefault(require("../../mobile/components/index"));
var _storyboardPlan = require("shared-libs/models/types/storyboard/storyboard-plan");
var _formulas = require("shared-libs/helpers/formulas");
var _utils = require("browser/app/utils/utils");
var _mobileHeaderContext = require("browser/mobile/contexts/mobile-header-context");
var _uiPropMapping = require("browser/contexts/prop-mapping/ui-prop-mapping");
var _uiPropMappingContext = require("shared-libs/components/context/ui-prop-mapping-context");
var _fetchServerTime = _interopRequireDefault(require("../utils/fetch-server-time"));
var _flagsmith = _interopRequireDefault(require("flagsmith"));
// global imports

// CSS import

// app import

// Minimum time offset before we apply a correction to returned Dates
var MINIMUM_OFFSET_MS = 1750;
(0, _device.registerDeviceInfoProvider)(new _deviceInfoProvider.WebDeviceInfoProvider());
(0, _bluebird.config)({
  // Enable warnings
  warnings: false,
  // Enable long stack traces
  longStackTraces: true,
  // Enable cancellation
  cancellation: true,
  // Enable monitoring
  monitoring: true
});
var App = function App() {
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Router, {
    history: _history.browserHistory
  }, /*#__PURE__*/_react["default"].createElement(_mobileHeaderContext.MobileHeaderContextProvider, null, /*#__PURE__*/_react["default"].createElement(_componentsContext.ComponentsContext.Provider, {
    value: {
      components: _index["default"],
      platform: _storyboardPlan.PlatformType.MOBILE_WEB
    }
  }, /*#__PURE__*/_react["default"].createElement(_uiPropMappingContext.UIPropMappingContext.Provider, {
    value: {
      getPropMappingStrategy: _uiPropMapping.getPropMappingStrategy
    }
  }, /*#__PURE__*/_react["default"].createElement(_mobileWebApp.MobileWebApp, null)))));
};

// register the app
_AppRegistry["default"].registerComponent('App', function () {
  return App;
});
var registerApplicationContextAndStart = function registerApplicationContextAndStart(offset) {
  _formulas.FormulaRegistry.registerApplicationContext({
    getDeeplinkHost: function getDeeplinkHost() {
      return _apis["default"].WEBAPP_URL;
    },
    getLocale: function getLocale() {
      return navigator.language;
    },
    getPlatform: function getPlatform() {
      return (0, _utils.getPlatform)();
    },
    getTruetimeOffset: function getTruetimeOffset() {
      return offset;
    },
    getStore: function getStore() {
      return _apis["default"].getStore();
    }
  });
  _AppRegistry["default"].runApplication('App', {
    initialProps: {},
    rootTag: document.getElementById('react-app')
  });
};
_flagsmith["default"].init({
  environmentID: 'WKzTQtRgNCENGZNMADizuR',
  enableAnalytics: true,
  realtime: true,
  api: 'https://flagsmith.withvector.com/api/v1/'
}).then(function () {
  return (0, _fetchServerTime["default"])();
}).then(function (time) {
  var timeOffset = time - Date.now();
  registerApplicationContextAndStart(Math.abs(timeOffset) > MINIMUM_OFFSET_MS ? timeOffset : 0);
})["catch"](function (err) {
  console.error("Failed to get time: ".concat(err));
  registerApplicationContextAndStart(0);
});